import axios from "axios";
import { compressImage } from "@/utils/compressImage";
import { ref } from "vue";
export default function useUpload() {
  const controller = ref(null);

  const uploadFile = async (event, type, item) => {
    try {
      if (!event.target.files.length) return true;
      controller.value = new AbortController();
      let file = event.target.files[0];
      if (type == "image") {
        const compressedBlob = await compressImage(file, {
          maxSizeMB: 0.8,
          maxWidthOrHeight: 800,
        });
        file = new File([compressedBlob], file.name, { type: file.type });
      }
      const form = new FormData();
      form.append("file", file);
      const response = await axios.post("file", form, {
        signal: controller.value.signal,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          item.status = percentCompleted;
        },
      });

      Object.assign(item, { path: response.data.path, status: "complete" });
    } catch (error) {
      window.networkError(error);
    }
  };

  const removeFile = async (files, index) => {
    const file = files[index];
    if (!file.id) controller.value?.abort();
    files.splice(index, 1);
  };

  return {
    uploadFile,
    removeFile,
    controller
  };
}
